<template>
  <div class="gk-form-container">
    <el-form ref="form" :model="formData" v-bind="form.attrs" v-on="form.listeners">
      <template v-for="(item, index) in form.items">
        <el-form-item :key="index" :label="item.label" :prop="getPropName(item)" v-bind="item.attrs || {}"
          v-if="!item.hidden" :class="item.className">
          <template v-if="item.labelTooltip" slot="label">
            <span>{{ item.label }}</span>
            <el-tooltip :content="item.labelTooltip" placement="top">
              <i class="el-icon-info gk-form-label-tooltip" :aria-label="item.labelTooltip" tabindex="0"></i>
            </el-tooltip>
          </template>
          <template v-if="item.type == 'file-upload-img'">
            <div style="display: flex" class="upload-img">
              <el-upload action="#" class="file-upload-img" :limit="item.limit" :show-file-list="false"
                :disabled="item.disabled" :on-change="handleFormFieldChange.bind(null, item)"
                :on-exceed="handleFileUploadExceed.bind(null, item)"
                :before-upload="handleFileBeforeUpload.bind(null, item)"
                :http-request="handleFileUpload.bind(null, item)" :auto-upload="true" v-bind="item.attrs || {}">
                <img :src="formData[getPropName(item)]" v-if="formData[getPropName(item)]" />
                <div v-else class="upload-img">
                  <i class="el-icon-plus"></i>
                  <div class="text">{{ item.text || "添加图片" }}</div>
                </div>
                <i class="el-icon-delete delete" v-if="formData[getPropName(item)]"
                  @click.stop="handleImgDel(null, item)"></i>
              </el-upload>
              <div class="tip" v-if="item.tip" v-html="item.h"></div>
            </div>
          </template>
          <template v-else-if="item.type == 'file-upload-img-mutiple'">
            <div class="el-upload_container">
              <div class="imgs">
                <template v-for="(i, index) in formData[getPropName(item)]">
                  <div class="img-list" :key="i" v-if="
                    formData[getPropName(item)] &&
                    formData[getPropName(item)].length
                  ">
                    <el-image v-if="i" style="width: 100px; height: 100px; border-radius: 6px" :src="i"
                      :preview-src-list="formData[getPropName(item)]" fit="cover">
                    </el-image>
                    <i class="el-icon-delete delete" v-if="i" @click.stop="handleImgDel(index, item)"></i>
                  </div>
                </template>
                <el-upload class="file-upload-img" action="#" :limit="item.limit" :show-file-list="false"
                  :disabled="item.disabled" :on-change="handleFormFieldChange.bind(null, item)"
                  :before-upload="handleImgBeforeUpload.bind(null, item)"
                  :http-request="handleFileUpload.bind(null, item)" :auto-upload="true" v-if="
                    item.limit > formData[getPropName(item)].length ||
                    !formData[getPropName(item)]
                  ">
                  <div class="upload-img">
                    <i class="el-icon-plus"></i>
                    <div class="text">{{ item.text || "添加图片" }}</div>
                  </div>
                </el-upload>
              </div>
              <div class="el-upload_showBtn">
                <el-button type="text" @click="handlePreview(item.imgUrl)">查看示例</el-button>
                <div class="tip" v-if="item.tip" v-html="item.h"></div>
              </div>
            </div>
          </template>
          <template v-else-if="item.type == 'file-upload-imgVideo-mutiple'">
            <div class="upload-img-mutiple">
              <div class="el-upload_container">
                <template v-for="(i, index) in formData[getPropName(item)]">
                  <div class="img-list" :key="i.url" v-if="
                    formData[getPropName(item)] &&
                    formData[getPropName(item)].length
                  ">
                    <el-image v-if="i.url && i.type.includes('image')"
                      style="width: 100px; height: 100px; border-radius: 6px" :src="i.url" :preview-src-list="[i.url]"
                      fit="cover">
                    </el-image>
                    <a draggable="false" class="rong-sight-play" v-if="i.url && i.type.includes('video')"></a>
                    <video v-if="i.url && i.type.includes('video')" :src="i.url" height="100" width="100"
                      style="border-radius: 6px; cursor: pointer" @click="handleShowVideo(i)"></video>
                    <i class="el-icon-delete delete" v-if="i.url" @click.stop="handleImgDel(index, item)"></i>
                  </div>
                </template>
                <el-upload class="file-upload-img" action="#" :limit="item.limit" :show-file-list="false"
                  :disabled="item.disabled" :on-change="handleFormFieldChange.bind(null, item)"
                  :before-upload="handleImgVideoBeforeUpload.bind(null, item)"
                  :http-request="handleFileUpload.bind(null, item)" :auto-upload="true" v-if="
                    (formData[getPropName(item)] &&
                      item.limit > formData[getPropName(item)].length) ||
                    !formData[getPropName(item)] ||
                    !formData[getPropName(item)].length
                  " v-bind="item.attrs || {}">
                  <div class="upload-img">
                    <i class="el-icon-plus"></i>
                    <div class="text">上传</div>
                  </div>
                </el-upload>
              </div>
              <div class="el-upload_showBtn">
                <el-button v-if="item.showBtn" type="text" @click="handlePreview(item.imgUrl)">查看示例</el-button>
                <div class="tip" v-if="item.tip" v-html="item.h"></div>
              </div>
            </div>
          </template>
          <template v-else-if="item.type == 'file-upload'">
            <el-upload multiple class="file-upload" action="#" :style="form.attrs && form.attrs.labelPosition == 'top'
                ? {
                  position: 'absolute',
                  right: 0,
                  top: '-50px',
                }
                : {}
              " :limit="item.limit" :show-file-list="false" :disabled="item.disabled"
              :on-change="handleFormFieldChange.bind(null, item)" :file-list="formData[getPropName(item)] || []"
              :on-exceed="handleFileUploadExceed.bind(null, item)"
              :before-upload="handleFileBeforeUpload.bind(null, item)" :http-request="handleFileUpload.bind(null, item)"
              :auto-upload="true">
              <el-button icon="el-icon-plus" size="mini" :type="item.btnType ? item.btnType : 'text'"
                :disabled="item.disabled || false">{{ item.text || "添加附件" }}</el-button>
              <span style="font-size: 12px; color: #409eff" v-if="
                formData[getPropName(item)] &&
                formData[getPropName(item)].length
              " class="fileCount">（{{ formData[getPropName(item)].length }}个文件）</span>
            </el-upload>
            <div class="gk-problem-files gk-project-files" v-if="
              formData[getPropName(item)] &&
              formData[getPropName(item)].length
            ">
              <dl class="gk-comments-item-bd-files-f" v-for="(f, i) in formData[getPropName(item)]" :key="f.fileUid">
                <dt :class="[
                  'gk-icon',
                  `gk-icon-${f.fileType == 'others' ? 'others' : f.subType}`,
                ]"></dt>
                <dd>
                  <span class="gk-comments-item-bd-files-t">{{
                    f.fileName
                  }}</span>
                </dd>
                <el-button type="text" icon="el-icon-download" @click="handleDownload(f)"></el-button>
                <el-button type="text" icon="el-icon-delete" @click="handleFileDel(item, i)"></el-button>
                <!-- <el-button type="text" class="gk-comments-item-bd-files-btn">收起</el-button> -->
              </dl>
            </div>
          </template>
          <template v-else-if="item.type == 'select'">
            <el-select v-model="formData[getPropName(item)]" :filterable="item.filterable"
              :placeholder="`请选择${item.label}`" :disabled="item.disabled" :clearable="item.clearable"
              :popper-class="item.popperClassName || 'gk-select'" @change="handleFormFieldChange(item)"
              :multiple="item.multiple">
              <el-option v-for="opt in item.options" :key="opt.value" :label="opt.label" :value="opt.value">
                <span :class="[item.classNameOption || '']">{{
                  opt.label
                }}</span>
              </el-option>
            </el-select>
          </template>
          <template v-else-if="item.type == 'select-remote'">
            <el-select v-model="formData[getPropName(item)]" :filterable="item.filterable"
              :placeholder="`请选择${item.label}`" :disabled="item.disabled" :clearable="item.clearable"
              @change="handleFormFieldChange(item)" :remote="item.remote" :remote-method="remoteMethod.bind(
                null,
                item.paramsKey,
                item.params,
                item.remoteAction,
                item.remoteActionHandler
              )
                " :paramsKey="item.paramsKey" @blur="onSelectBlur($event, item)">
              <el-option v-for="opt in optionsRemote || item.options" :key="opt[item.valueName]"
                :label="opt[item.labelName]" :value="opt[item.valueName]">
                <span :class="[item.classNameOption || '']">{{
                  opt[item.labelName]
                }}</span>
              </el-option>
            </el-select>
          </template>
          <template v-else-if="item.type == 'select-remote-input'">
            <template v-if="item.showType == 'input'">
              <el-input style="width: 202px; margin-right: 10px" :class="[item.className || '']"
                v-model="formData[getPropName(item)]" :maxlength="item.maxlength" :minlength="item.minlength"
                :placeholder="item.placeholder ? item.placeholder : `请输入${item.label}`
                  " :disabled="item.disabled" :clearable="item.clearable" :show-word-limit="item.showWordLimit" />
              <el-tooltip class="item" effect="dark" content="返回搜索" placement="top">
                <span style="cursor: pointer" title="返回搜索" @click="handleFormFieldChange(item)"><i
                    class="el-icon-refresh-left"></i></span>
              </el-tooltip>
            </template>
            <el-select v-else v-model="formData[getPropName(item)]" :filterable="item.filterable"
              :placeholder="`请选择${item.label}`" :disabled="item.disabled" :clearable="item.clearable"
              :remote="item.remote" :remote-method="remoteMethod.bind(
                null,
                item.paramsKey,
                item.params,
                item.remoteAction,
                item.remoteActionHandler
              )
                " :paramsKey="item.paramsKey">
              <template slot="empty">
                <div class="remote-empty">
                  搜索不到？<span @click="handleFormFieldChange(item)"><i class="el-icon-edit"></i>点击输入</span>
                </div>
              </template>
              <el-option v-for="opt in optionsRemote || item.options" :key="opt[item.valueName]"
                :label="opt[item.labelName]" :value="opt[item.valueName]">
                <span :class="[item.classNameOption || '']">{{
                  opt[item.labelName]
                }}</span>
              </el-option>
            </el-select>
          </template>
          <template v-else-if="item.type == 'cascader'">
            <el-cascader v-model="formData[getPropName(item)]" :options="item.options" :props="item.props"
              :placeholder="item.placeholder || `请选择${item.label}`" :disabled="item.disabled"
              :clearable="item.clearable" :key="item.prop" @change="handleFormFieldChange(item)">
            </el-cascader>
          </template>
          <template v-else-if="item.type == 'cascader-input'">
            <template v-if="item.showType == 'input'">
              <el-input style="width: 350px; margin-right: 10px" :class="[item.className || '']"
                v-model="formData[getPropName(item)]" :maxlength="item.maxlength" :minlength="item.minlength"
                :placeholder="item.placeholder ? item.placeholder : `请输入${item.label}`
                  " :disabled="item.disabled" :clearable="item.clearable" :show-word-limit="item.showWordLimit" />
              <el-tooltip class="item" effect="dark" content="返回搜索" placement="top">
                <span style="cursor: pointer" title="返回搜索" @click="handleFormFieldChange(item)"><i
                    class="el-icon-refresh-left"></i></span>
              </el-tooltip>
            </template>
            <el-cascader v-else style="width: 350px" v-model="formData[getPropName(item)]" :options="item.options"
              :props="item.props" :placeholder="item.placeholder || `请选择${item.label}`" :disabled="item.disabled"
              :clearable="item.clearable" :filterable="item.filterable" :key="item.prop">
              <template slot="empty">
                <div class="remote-empty">
                  搜索不到？<span @click="handleFormFieldChange(item)"><i class="el-icon-edit"></i>点击输入</span>
                </div>
              </template>
            </el-cascader>
            <!-- <el-button style="display: block;margin-top: 12px;" type="primary" size="small"
              @click="handleFormFieldChange(item, 'btn')">{{
                item.btnText ||
                '' }}</el-button> -->
          </template>
          <template v-else-if="item.type == 'datepicker'">
            <!-- <el-date-picker
                          v-model="formData[ getPropName(item) ]"
                          type="date"
                          :value-format="item.valueFomat ? item.valueFomat : 'yyyy-MM-dd'"
                          :placeholder="`请选择${ item.label }`"
                          :disabled="item.disabled"
                      /> -->
            <el-date-picker style="width: 213px" v-model="formData[getPropName(item)]"
              :type="item.dateType ? item.dateType : 'date'" :format="item.format ? item.format : 'yyyy/MM/dd'"
              :placeholder="`请选择${item.label}`" :disabled="item.disabled" :clearable="item.clearable"
              v-bind="item.attrs || {}" @on-change="handleFormFieldChange(item)" />
          </template>
          <template v-else-if="item.type == 'datepicker-time'">
            <el-date-picker style="width: 213px" v-model="formData[getPropName(item)]" type="datetime"
              :format="item.format ? item.format : 'yyyy/MM/dd HH:mm'" :placeholder="`请选择${item.label}`"
              :disabled="item.disabled" :clearable="item.clearable" />
          </template>
          <template v-else-if="item.type == 'datepicker-range'">
            <el-date-picker type="daterange" style="width: 230px" v-model="formData[getPropName(item)]"
              range-separator=" 至 " :format="item.format ? item.format : 'yyyy/MM/dd'" :placeholder="`请选择${item.label}`"
              :options="item.options" :disabled="item.disabled" :clearable="item.clearable" />
          </template>
          <template v-else-if="item.type == 'textarea'">
            <el-input :class="[item.className || '']" v-model="formData[getPropName(item)]" type="textarea"
              :rows="item.rows" :maxlength="item.maxlength" :placeholder="item.placeholder || `请输入${item.label}`"
              :disabled="item.disabled" :clearable="item.clearable" :show-word-limit="item.showWordLimit" resize="none"
              @change="handleFormFieldChange(item)" />
          </template>
          <template v-else-if="item.type == 'radio'">
            <el-radio-group v-model="formData[getPropName(item)]">
              <el-radio :label="item.value" v-for="item in item.options" :key="item.value">{{ item.label }}</el-radio>
            </el-radio-group>
          </template>
          <template v-else-if="item.type == 'map-selection'">
            <div style="display: flex; align-items: center">
              <span style="line-height: 25px; color: #0867a4; cursor: pointer" @click="openMapPlugin(item)">{{
                formData[getPropName(item)]
                  ? formData[getPropName(item)][getPropName(item)]
                  : "请选择地址"
              }}<i class="el-icon-location-information"
                  style="margin-left: 15px; font-size: 20px; color: #0867a4"></i>
              </span>
            </div>
          </template>
          <template v-else-if="item.type == 'input-number'">
            <el-input-number v-model="formData[getPropName(item)]" v-bind="item.attrs || {}"
              :placeholder="item.placeholder || `请输入${item.label}`"></el-input-number>
          </template>
          <template v-else-if="item.type == 'checkbox-group'">
            <el-checkbox-group v-model="formData[getPropName(item)]" v-bind="item.attrs || {}" :min="item.min"
              :max="item.max">
              <el-checkbox v-for="(v, index) in item.options" :label="v.value" :key="v.value" :disabled="v.disabled"
                @change="(e) => handleChange(e, index, item, v.value)">{{ v.label }}</el-checkbox>
            </el-checkbox-group>
          </template>
          <template v-else-if="item.type == 'edit-table'">
            <el-table
              :data="formData[getPropName(item)]"
              :columns="item.tableColumns"
              border
              width="100%"
              max-height="500"
            >
              <el-table-column
                v-for="(h, i) in item.tableColumns"
                :key="i"
                :label="h.title"
                :align="h.align"
              >
                <template #default="{ row, $index }" >
                  <div>
                    <el-input v-if="h.type == 'input'" v-model="row[h.key]" placeholder="请输入内容" clearable
                      :disabled="h.disabled || false" @input="tableInputChange(item, h, row, $index)" />

                    <el-select v-else-if="h.type == 'select'" v-model="row[h.key]" :disabled="h.disabled || false"
                      @change="tableInputChange(item, h, row, $index)" placeholder="请选择" clearable>
                      <el-option v-for="o in h.options" :key="o.value" :label="o.label" :value="o.value" />
                    </el-select>

                    <DatePicker v-else-if="h.type == 'date-picker'" v-model="row[h.key]" :disabled="h.disabled || false"
                      type="date" placeholder="选择日期" format="yyyy年MM月dd日" clearable
                      @on-change="tableInputChange(item, h, row, $index)"
                    />

                    <div class="file-upload-img-groups" v-else-if="h.type == 'file-upload-img'">
                      <div class="success-imgs" :class="{ 'file-upload-img-more': item.limit > 1 }">
                        <div class="upload-more">
                          <div class="image-container" v-for="(x, j) in formData[getPropName(item)][index][
                            h.key
                          ]" :key="j">
                            <img :src="x" v-if="x" />
                            <div class="overlay">
                              <i class="el-icon-zoom-in" style="color: #ffffff; font-size: 17px"
                                @click="handlePreview(x), false"></i>
                              <i class="el-icon-delete" style="
                                 color: #ffffff;
                                  margin-left: 15px;
                                  font-size: 17px;
                                " @click="deleteImg(item, h, row, $index, j)"></i>
                            </div>
                          </div>
                          <el-upload v-if="!row[h.key] || h.limit > row[h.key].length" class="file-upload-img" action="#"
                            :limit="h.limit" :show-file-list="false" :disabled="h.disabled"
                            :on-exceed="handleFileUploadExceed.bind(null, h)"
                            :before-upload="handleFileBeforeUpload.bind(null, h)" :http-request="file =>
                              handleTableImgUpload(file, item, h, row, $index)
                            " :auto-upload="true">
                            <div class="upload-img">
                              <i class="el-icon-plus" style="font-size: 24px"></i>
                              <div class="text">{{ h.text || "上传图片" }}</div>
                            </div>
                          </el-upload>
                        </div>
                      </div>
                    </div>

                    <div v-else-if="h.type == 'Actions'" class="el-form_table-action">
                      <div v-for="(m, n) in h.actions" :key="n" class="el-form_table-action_buttons">
                        <template v-if="m == 'delete'">
                          <el-button class="el-button_danger" @click="deleterTableRow(item, row, $index)" type="text">
                            <i class="el-icon-delete" />删除
                          </el-button>
                        </template>
                      </div>
                      <slot name="elFormTableActionSlot" v-bind="{ row, $index, item }" />
                    </div>

                    <div v-else>
                      {{ row[h.key] }}
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>

            <div style="
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  ">
              添加
              <i class="el-icon-circle-plus" style="cursor: pointer; color: #409eff; font-size: 25px"
                @click="addTableRow(item, index)" />
            </div>
          </template>
          <template v-else-if="item.type == 'input-autocomplete'">
            <el-autocomplete v-model="formData[getPropName(item)]"
              :fetch-suggestions="querySearchAsync.bind(null, item)"
              :placeholder="item.placeholder || `请输入${item.label}`"
              @select="(data) => handleSelectAutocomplete(item, data)"></el-autocomplete>
          </template>
          <template v-else>
            <el-input :class="[item.className || '']" v-model="formData[getPropName(item)]" :maxlength="item.maxlength"
              :minlength="item.minlength" :placeholder="item.placeholder ? item.placeholder : `请输入${item.label}`
                " :disabled="item.disabled" :clearable="item.clearable" :show-word-limit="item.showWordLimit"
              @change="handleFormFieldChange(item)" />
          </template>
        </el-form-item>
      </template>

      <el-form-item>
        <slot name="btns"></slot>
      </el-form-item>
    </el-form>
    <el-dialog :modal-append-to-body="false" :visible.sync="dialogVisible">
      <img v-if="!localAssets && imgUrl" width="100%" :src="imgUrl" alt="" />
      <!-- <img v-if="imgUrl && localAssets" width="100%" :src="require(`../../../../../public/css/images/${imgUrl}`)"
          alt="" /> -->
    </el-dialog>
    <map-view :mapId="mapId" v-model="mapVisible" @mapSelection="mapSelection" @onDialogClose="onDialogClose"
      :addressInfo="formMapItem" />

    <!-- 表格弹框 -->
    <el-dialog :title="formTableConfig.title" :visible.sync="tableDialogVisible" width="50%" append-to-body
      class="add-dialog" center destroy-on-close :modal="false" :close-on-click-modal="false" @open="handleOpen">
      <gk-form ref="tableFormRef" :form="formTableConfig.formItems" />

      <template #footer>
        <span class="dialog-footer">
          <el-button class="btn cancel" @click="tableDialogVisible = false">取 消</el-button>
          <el-button type="primary" class="btn add" @click="handleFormTableSure(formTableConfig)">{{
            formTableConfig.submitText || "保 存" }}</el-button>
        </span>
      </template>
    </el-dialog>
    <video-viewer v-model="showVideoDialog" :videoSrc="videoSrc" />
  </div>
</template>

<script>
/* eslint-disable */
import moment from "moment";
import { saveAs } from "file-saver";
import { uploadFiles } from "@api/user";

import {
  getHomeListApi,
  getMemberListApi,
  getPartyListApi,
} from "@api/project";
import file_suffix_dic from "@constants/file-type";
import MapView from "./mapView.vue";
import videoViewer from '@views/workspace/components/video-viewer-dialog.vue'

export default {
  name: "gk-form",
  props: {
    form: Object,
    onUploadSuccess: Function,
    mapId: String,
    formTableConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    MapView,
    videoViewer
  },
  data() {
    return {
      formData: {},
      dialogVisible: false,
      imgUrl: "",
      mapVisible: false,
      formMapItem: {},
      localAssets: true,
      optionsRemote: "",
      tableDialogVisible: false, // 表格弹框
      formTableData: {},
      showVideoDialog: false,
      videoSrc: ''
    };
  },
  watch: {
    "form.items": {
      handler(v) {
        this.initFormData(v);
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    onSelectBlur(e, item) {
      const { noInput } = item;
      if (e.target.value && !noInput) {
        this.formData[this.getPropName(item)] = e.target.value;
        this.$forceUpdate();
      }
    },

    //远程搜索
    async remoteMethod(
      key,
      params,
      fnName = "getPartyListApi",
      remoteActionHandler,
      val
    ) {
      const _remoteFn = { getHomeListApi, getMemberListApi, getPartyListApi };
      const _params = { [key]: val, ...params };
      const res = await _remoteFn[fnName](_params);
      const result = res && res.result;
      if (result) {
        if (
          remoteActionHandler &&
          Object.prototype.toString.call(remoteActionHandler) ===
          "[object Function]"
        ) {
          this.optionsRemote = remoteActionHandler(result);
        } else {
          if (Array.isArray(result)) {
            this.optionsRemote = result || [];
          }

          if (Object.prototype.toString.call(result) === "[object Object]") {
            this.optionsRemote =
              (result.data && result.data.length ? result.data : []) || [];
          }
        }
      }
    },
    async querySearchAsync(item, queryString, cb) {
      const _params = { ...item.params, [item.paramsKey]: queryString };
      const _remoteFn = { getHomeListApi };
      const res = await _remoteFn[item.remoteAction](_params);
      const result = res && res.result;
      if (result) {
        const cbData = item.remoteResultHandler
          ? item.remoteResultHandler(result)
          : result.data || [];
        cb(cbData);
      } else {
        cb([]);
      }
    },
    handleSelectAutocomplete(item, option) {
      const _prop = item.prop;
      const _data = this.resetFormData(this.getPropName(item));
      this.$emit("on-fields-change", _prop, _data[_prop], item, option);
    },
    //查看实例图片
    handlePreview(imgUrl, localAssets) {
      this.dialogVisible = true;
      this.imgUrl = imgUrl;
      this.localAssets = localAssets;
    },
    // 文件上传-上传限制
    handleFileUploadExceed(item, f, files, list) {
      const { limit } = item;
      this.$message({
        message: `最多上传${limit}个文件`,
        type: "error",
      });
    },
    // 和文件小助手 gk-fileassistant-admin 的上传类型对应
    getFileInfo(file) {
      let _info = {};
      if (file) {
        let { name, size } = file;
        let type = "others";
        let subType = "";
        if (name.includes(".")) {
          name = name.split(".");
          subType = name[name.length - 1].toLowerCase();
          name = name.join(".");
          file_suffix_dic.forEach((d) => {
            if (d.suffixs && d.suffixs.includes(subType)) {
              type = d.type;
            }
          });
        }
        _info = {
          name,
          size,
          type,
          subType,
        };
      }
      return _info;
    },

    // 上传前校验
    handleFileBeforeUpload(item, f) {
      const fileType =
        item.attrs && item.attrs.accept ? item.attrs.accept.split(",") : [];
      const { maxSize = 5 } = item;
      const { name, size, type } = this.getFileInfo(f);
      const isAccept = fileType.includes(f.type);

      if (fileType.length && !isAccept) {
        let accept = [];
        fileType.forEach((type) => {
          accept.push(type.substr(type.lastIndexOf("/") + 1));
        });
        this.$message({
          message: `请上传${accept.join("或")}格式的文件`,
          type: "error",
        });
        return false;
      }

      if (!size) {
        this.$message({
          message: "上传文件不能为空",
          type: "error",
        });
        return false;
      }

      if (type == "audio" || type == "video") {
        this.$message({
          message: "暂不支持上传音视频文件",
          type: "error",
        });

        return false;
      }

      if (size > maxSize * 1024 * 1024) {
        this.$message({
          message: `${name}，超过最大上传限制${maxSize}M`,
          type: "error",
        });
        return false;
      }

      return true;
    },

    // 图片上传前校验
    handleImgBeforeUpload(item, f) {
      const { maxSize = 5 } = item;
      const { name, size, type } = this.getFileInfo(f);
      if (!size) {
        this.$message({
          message: "上传文件不能为空",
          type: "error",
        });
        return false;
      }
      if (type == "audio" || type == "video") {
        this.$message({
          message: "暂不支持上传音视频文件",
          type: "error",
        });
        return false;
      }
      if (size > maxSize * 1024 * 1024) {
        this.$message({
          message: `${name}，超过最大上传限制${maxSize}M`,
          type: "error",
        });
        return false;
      }
      if (type != "img" || type != "video") {
        this.$message({
          message: "文件格式不支持",
          type: "error",
        });
        return false;
      }
      return true;
    },
    // 图片视频上传前校验
    handleImgVideoBeforeUpload(item, f) {
      const { maxSize = 5, noLimitSize } = item;
      const { name, size, type, subType } = this.getFileInfo(f);
      if (!size) {
        this.$message({
          message: "上传文件不能为空",
          type: "error",
        });
        return false;
      }
      if (!noLimitSize && size > maxSize * 1024 * 1024) {
        this.$message({
          message: `${name}，超过最大上传限制${maxSize}M`,
          type: "error",
        });
        return false;
      }
      if (type != "img" && type != "video") {
        this.$message({
          message: "文件格式不支持",
          type: "error",
        });
        return false;
      }
      if (type == "video" && ["wmv", "avi"].includes(subType)) {
        this.$message({
          message: "请上传mp4格式视频",
          type: "error",
        });
        return false;
      }
      if (item.fileType && type != item.fileType) {
        this.$message({
          message: "文件格式不支持",
          type: "error",
        });
        return false;
      }
      return true;
    },
    //视频播放
    handleShowVideo({ url }) {
      this.showVideoDialog = true
      this.videoSrc = url
      // imageViewer.openWin({
      //   dataSource: [
      //     {
      //       url: url,
      //       type: 'SightMessage',
      //     },
      //   ],
      //   defaultIndex: 0,
      //   locale: config.locale,
      // })
    },
    //删除图片
    handleImgDel(index, { prop }) {
      if (index === null) {
        this.formData = {
          ...this.formData,
          [prop]: '',
        };
      } else {
        this.formData = {
          ...this.formData,
          [prop]: this.formData[prop].filter((item, i) => i != index),
        };
      }

    },
    // 删除文件
    handleFileDel({ prop }, i) {
      const data = this.formData[prop].filter((f, index) => index != i);
      this.formData = {
        ...this.formData,
        [prop]: [...data],
      };
    },
    //下载文件
    handleDownload({ fileUrl = "", fileName = "" }) {
      if (fileUrl && fileName) {
        saveAs(fileUrl, fileName);
      } else {
        this.$message.error("下载失败，请重试");
      }
    },
    // 问题文件上传
    async handleFileUpload({ prop, type }, { file }) {
      const context = this;
      const result = await uploadFiles({
        type: "PUBLIC",
        file,
      })
      if (result && result.ossUrl && type == "file-upload-img") {
        context.formData[prop] = result.url;
      } else if (result && result.ossUrl && type == "file-upload-img-mutiple") {
        context.formData = {
          ...context.formData,
          [prop]: [...context.formData[prop], result.url],
        };
      } else if (
        result &&
        result.ossUrl &&
        type == "file-upload-imgVideo-mutiple"
      ) {
        context.formData = {
          ...context.formData,
          [prop]: [
            ...context.formData[prop],
            { url: result.url, type: result.mime },
          ],
        };
      } else {
        if (result && result.ossUrl) {
          const { name, size, type, subType } = context.getFileInfo(file);
          const _flist = context.formData[prop];
          const _curFile = {
            fileUrl: result.ossUrl,
            fileName: name,
            fileSize: size,
            fileType: type,
            subType,
          };
          context.formData = {
            ...context.formData,
            [prop]: [
              ..._flist,
              {
                fileUid: `f_${Math.random()}`.replace('.', ''),
                ..._curFile,
              },
            ],
          };
          if (context.onUploadSuccess) {
            context.$emit("on-upload-success", _curFile);
          }
        }
      }
    },
    getPropName(item) {
      const { prop } = item;
      return Array.isArray(prop) ? prop.join("@") : prop;
    },
    initFormData(items) {
      const _formData = {};
      items.forEach((item) => {
        if (Array.isArray(item.prop)) {
          _formData[item.prop.join("@")] = item.initValue || "";
        } else {
          //formData用来保留原来输入数据
          const _complexType =
            Object.prototype.toString.call(item.initValue) ===
            "[object Object]" ||
            Object.prototype.toString.call(item.initValue) === "[object Array]";

          const _initValue = _complexType
            ? JSON.parse(JSON.stringify(item.initValue))
            : item.initValue;

          _formData[item.prop] = item.formData
            ? this.formData[item.prop] || _initValue
            : item.initValue === 0
              ? item.initValue
              : _initValue || "";
        }
      });
      this.formData = {
        ...this.formData,
        ..._formData,
      };
    },
    resetFormData(filterKey) {
      const { items } = this.form;
      const _params = {};
      let _keys = Object.keys(this.formData);
      if (filterKey) {
        _keys = _keys.filter((k) => k == filterKey);
      }
      _keys.forEach((k) => {
        if (k.includes("@")) {
          k.split("@").forEach((kn, i) => {
            _params[kn] = this.formData[k][i] || "";
          });
        } else {
          _params[k] =
            this.formData[k] || this.formData[k] == 0 ? this.formData[k] : "";
        }
      });
      Object.entries(_params).forEach(([k, v]) => {
        let _res = items.find((i) => {
          if (Array.isArray(i.prop)) {
            return i.prop.find((p) => p == k);
          } else {
            return i.prop == k;
          }
        });
        if (_res && v) {
          if (_res.type == "members-mutiple") {
            _params[k] = v.map((d) => d.gk_id);
          } else if (_res.type == "members-single") {
            _params[k] = v[0].gk_id;
          } else if (
            _res.type == "datepicker" ||
            _res.type == "datepicker-range" ||
            _res.type == "datepicker-time"
          ) {
            let _format = _res.format;
            if (_format) {
              _format = _format.replace(/y/g, "Y").replace(/d/g, "D");
            } else {
              _format = `YYYY/MM/DD${_res.type == "datepicker-time" ? " HH:mm" : ""
                }`;
            }
            _params[k] = moment(v).format(_format);
          }
        }
      });

      return _params;
    },
    handleSubmit() {
      return new Promise((resolve, reject) => {
        const { attrs = {} } = this.form;
        const { rules } = attrs;
        if (rules) {
          this.$refs.form.validate((valid) => {
            if (valid) {
              resolve(this.resetFormData());
            } else {
              reject(valid);
              return false;
            }
          });
        } else {
          resolve(this.resetFormData());
        }
      });
    },
    handleFormFieldChange(item, type) {
      const _data = this.resetFormData(this.getPropName(item));
      const _prop = item.prop;
      if (Array.isArray(_prop)) {
        const _emitData = {};
        _prop.forEach((p) => {
          _emitData[p] = _data[p];
        });
        this.$emit("on-fields-change", _prop, _emitData);
      } else {
        this.$emit("on-fields-change", _prop, _data[_prop], item, type);
      }
      if (this.$refs.form) {
        this.$refs.form.clearValidate(item.prop);
      }
    },
    handleFileChange(item, file, fileList) {
      console.log(item);
      console.log(file);
      console.log(fileList);
    },
    handleChange(e, index, item, value) {
      const _prop = item.prop;
      const _data = this.resetFormData(this.getPropName(item));
      this.$emit("on-fields-change", _prop, _data[_prop], item, {
        status: e,
        index,
        value,
      });
    },
    handleReset() {
      this.$refs.form.resetFields();
      this.formData = {};
    },
    handleClear() {
      this.$refs.form.clearValidate();
    },
    // 打开高德地图
    openMapPlugin(item) {
      this.formMapItem = item;
      this.mapVisible = true;
    },
    // 关闭高德地图
    onDialogClose() {
      this.mapVisible = false;
    },
    // 设置高德地图数据
    mapSelection(val) {
      if (val.address) {
        this.formData[this.formMapItem.prop] = {
          [this.formMapItem.prop]: val.kqLocation,
          longitude: val.kqLongitude,
          latitude: val.kqLatitude,
        };

        if (this.$refs.form) {
          this.$refs.form.clearValidate(this.formMapItem.prop);
        }
      }
      this.mapVisible = false;
    },
    tableInputChange(item, h, row, index) {
      if (h.type == "date-picker") {
        this.formData[this.getPropName(item)][index][h.key] = moment(
          row[h.key]
        ).format("YYYY/MM/DD");
      } else {
        this.formData[this.getPropName(item)][index][h.key] = row[h.key];
      }
    },
    deleterTableRow(item, row, index) {
      this.formData[this.getPropName(item)].splice(index, 1);
    },
    addTableRow(item, index) {
      this.$emit("add-table-row", { item, index });
    },
    // 表格圖片上传
    async handleTableImgUpload({ file }, item, h, row, index) {
      const context = this;
      const result = await uploadFiles({
        type: "PUBLIC",
        file,
      });
      if (result && result.ossUrl) {
        row[h.key] = [...(row[h.key] || []), result.ossUrl];
        this.$set(
          context.formData[context.getPropName(item)][index],
          [h.key],
          row[h.key]
        );
      }
    },
    deleteImg(item, h, row, index, j) {
      let imgs = this.formData[this.getPropName(item)][index][h.key] || [];
      imgs.splice(j, 1);
      this.$set(this.formData[this.getPropName(item)][index], [h.key], imgs);
    },

    handleDateRules() {
      this.resetFormData();
    },

    handleOpen() {
      this.$nextTick(() => {
        this.$refs.tableFormRef.handleClear();
      });
    },

    handleShowTableDialog() {
      this.tableDialogVisible = true;
    },

    handleOperateFormTableData(res, item, status, index, row) {
      if (status === "edit") {
        this.$set(this.formData[this.getPropName(item)], index, {
          ...row,
          ...res,
        });
      } else {
        this.formData[this.getPropName(item)].push(res);
      }
    },

    async handleFormTableSure() {
      const res = await this.$refs.tableFormRef.handleSubmit();

      if (res) {
        this.tableDialogVisible = false;
        this.$emit("form-table-sure", res);
      }
    },
  },
};
</script>

<style lang="scss">
.upload-img {
  .file-upload-img {
    height: 100px;
    font-size: 12px;
    position: relative;
    margin-right: 16px;

    img {
      width: 100px;
      height: 100px;
      border-radius: 6px;
    }

    .upload-img {
      width: 100px;
      height: 100px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-radius: 6px;
      border: 1px solid #c8c8c8;
      color: #8b8b8b;
    }

    .delete {
      z-index: 99;
      position: absolute;
      top: 5px;
      right: 5px;
      font-size: 20px;
      color: #333;
    }

    .delete:hover {
      color: #f56c6c;
      cursor: pointer;
    }
  }

  .tip {
    color: #a8a8a8;
    font-size: 12px;
    line-height: 25px;
  }
}

.upload-img-mutiple {
  display: flex;
  flex-direction: column;

  .el-upload_container {
    display: flex;
    flex-wrap: wrap;
  }

  img {
    width: 100px;
    height: 100px;
    border-radius: 6px;
  }

  .img-list {
    position: relative;
    margin-right: 10px;
    margin-bottom: 10px;
    width: 100px;
    height: 100px;

    .delete {
      z-index: 99;
      position: absolute;
      top: 5px;
      right: 5px;
      font-size: 20px;
      color: #333;
    }

    .delete:hover {
      color: #f56c6c;
      cursor: pointer;
    }
  }

  .file-upload-img {
    height: 100px;
    font-size: 12px;
    position: relative;

    .upload-img {
      width: 100px;
      height: 100px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-radius: 6px;
      border: 1px solid #c8c8c8;
      color: #8b8b8b;
    }
  }

  .tip {
    color: #a8a8a8;
    font-size: 12px;
    line-height: 25px;
  }
}

.parent-task {
  display: inline-block;
  max-width: 200px !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.gk-form-container {

  .gk-form-label-tooltip {
    margin-left: 6px;
    color: #909399;
    cursor: help;
  }

  .el-input__inner,
  .el-input__inner,
  .ivu-input {
    border-radius: 6px;
    border: 1px solid #c8c8c8;
  }

  .el-input.is-active .el-input__inner,
  .el-input__inner:focus,
  .el-select .el-input.is-focus .el-input__inner {
    border-color: #008af3;
  }

  .ivu-input:focus,
  .ivu-date-picker-focused input:not([disabled]) {
    border-color: #008af3;
    box-shadow: none;
  }

  .el-form-item__label {
    color: #1d2129;
    // color: #89919F;
  }

  .el-textarea {
    padding-bottom: 40px;
  }

  .el-textarea__inner {
    border-radius: 6px;
    border: none;
    background: #f7f7f7;
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .el-input__count {
    background: none;
  }

  .el-input__inner.mutiple {
    position: relative;
    padding-right: 90px;
    overflow: hidden;
    height: auto;
    min-height: 40px;
  }

  .members-mutiple-add {
    position: absolute;
    right: 8px;
    top: 5px;
  }

  .members-tag {
    display: inline-flex;
    align-items: center;
    background-color: #f5f5f5;
    height: 26px;
    padding: 0 3px;
    border-radius: 12px;
    margin: 5px 10px 0 0;

    &-name {
      margin: 0 5px;
      font-size: 14px;
      line-height: 20px;
      color: #333;
    }

    .el-icon-close {
      color: #333;
      font-size: 16px;
      cursor: pointer;
    }
  }

  .members-single-add {
    float: right;
    color: #008af3;
    cursor: pointer;
  }

  .members-placeholder {
    color: #c6c9d1;
  }

  .gk-project-files .gk-comments-item-bd-files-f .el-button {
    width: 20px;
    margin-right: 10px;
    margin-left: 0 !important;
  }

  .el-avatar>img {
    width: 100%;
  }

  .ivu-input {
    height: 36px;
    padding: 4px 15px;
  }

  .ivu-input-icon {
    height: 36px;
    line-height: 36px;
  }

  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 36px;
  }

  .el-input.is-disabled .el-input__inner,
  .el-textarea.is-disabled .el-textarea__inner,
  .ivu-input[disabled],
  fieldset[disabled] .ivu-input {
    background: #f7f7f7;
    border: none;
    color: #888;
    cursor: default;
  }

  .el-select .el-input.is-disabled .el-input__inner {
    cursor: default;
  }

  .el-input.is-disabled .el-input__inner {
    padding: 0 15px;
  }

  .el-input.is-disabled .el-input__prefix,
  .el-input.is-disabled .el-input__suffix,
  .ivu-input-wrapper-disabled .ivu-input-prefix,
  .ivu-input-wrapper-disabled .ivu-input-suffix {
    display: none;
  }

  .el-textarea.is-disabled .el-textarea__inner {
    padding: 8px 15px;
  }

  .ivu-table .el-input {
    width: 100% !important;
  }

  .ivu-table-cell {
    padding-top: 9px;
    padding-bottom: 9px;
  }
}

.success-imgs {
  display: flex;

  .image-container {
    width: 100px;
    height: 100px;
    border-radius: 6px;
    overflow: hidden;
    position: relative;
    display: inline-block;
    margin-right: 15px;
    margin-bottom: 15px;
  }

  .image-container img {
    display: block;
    width: 100%;
    height: 100%;
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    opacity: 0;
    transition: opacity 0.5s ease;
    display: flex;
    justify-content: center;
    align-items: center;

    i {
      cursor: pointer;
    }
  }

  .image-container:hover .overlay {
    opacity: 1;
  }

  .upload-more {
    display: flex;
    flex-flow: wrap;
  }

  .file-upload-describe {
    line-height: 25px;
    flex-shrink: 1;
    font-size: 12px;
    color: #a8a8a8;

    .btn {
      color: #008af3;
      text-decoration-line: underline;
      cursor: pointer;
    }
  }
}

.file-upload-img-more {
  flex-flow: wrap;
}

.file-upload-img {
  .upload-img {
    width: 100px;
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #c8c8c8;
    color: #8b8b8b;
    font-size: 12px;
    margin-right: 15px;
  }
}

.file-upload-img-groups {
  display: flex;
}

.rong-im ::-webkit-scrollbar {
  height: 2px !important;
}

.el-button_danger {
  color: #f56c6c;

  &:hover,
  &:focus {
    color: #f56c6c;
  }
}

.el-dialog {
  border-radius: 3%;
  height: 60%;

  .el-dialog__footer {
    position: absolute;
    bottom: 0;
    right: 0;

    .btn {
      border-radius: 6px 6px 6px 6px;
      font-size: 12px;
      font-weight: bold;
    }

    .cancel {
      color: #a4acb9;
    }
  }

  .tip {
    height: 18px;
    font-size: 12px;
    font-weight: 500;
    color: #c8c8c8;
    line-height: 18px;
  }
}

.el-form_item-textarea {
  .el-form-item__error {
    top: 75% !important;
  }
}

.remote-empty {
  padding: 10px;
  color: #999;
  font-size: 12px;

  span {
    color: #409eff;
    cursor: pointer;

    i {
      margin-right: 3px;
    }
  }
}
</style>
